module.exports = __webpack_public_path__ + "img/isabel-garcia.f46f70a4.jpg";